import { AlertCircle } from 'lucide-react';
import { useCondoContext } from '@/features/auth/use-condo-context';
import { useDashboardFinanciero } from '@/features/dashboard/api';
import { DashboardFinanciero } from '@/features/dashboard/dashboard-financiero';
import { ProximosVencimientosFinanciero } from '@/features/dashboard/proximos-vencimientos-financiero';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Skeleton } from '@/components/ui/skeleton';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { formatPeriodo } from '@/lib/format/date';

export function DashboardFinancieroRoute() {
  const { condoId } = useCondoContext();
  const { data, isLoading, error } = useDashboardFinanciero(condoId);

  return (
    <PageContainer>
      <PageHeader
        eyebrow="Finanzas"
        title="Dashboard Financiero"
        subtitle={
          data
            ? `Periodo ${formatPeriodo(data.periodo)}`
            : 'Indicadores financieros del condominio'
        }
      />

      {error && (
        <Alert variant="danger" className="mb-6">
          <AlertCircle />
          <AlertTitle>No se pudo cargar el dashboard</AlertTitle>
          <AlertDescription>{String(error)}</AlertDescription>
        </Alert>
      )}

      {isLoading || !data ? (
        <div className="space-y-6">
          <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
            <Skeleton className="h-40" />
            <Skeleton className="h-40" />
          </div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Skeleton key={i} className="h-32" />
            ))}
          </div>
        </div>
      ) : (
        <>
          <DashboardFinanciero data={data} />

          {/* Row 3: Proximos vencimientos */}
          <section className="mt-6">
            <article className="stagger-fade rounded-md border border-[var(--color-hairline)] bg-[var(--color-paper)] p-6">
              <header className="pb-4">
                <p className="eyebrow">Proximos vencimientos</p>
                <h2 className="font-display mt-1 text-xl font-semibold">
                  Calendario de cobro
                </h2>
              </header>
              <ProximosVencimientosFinanciero
                items={data.proximosVencimientos}
              />
            </article>
          </section>
        </>
      )}

      <footer className="mt-10 text-[0.6875rem] text-[var(--color-ink-faint)]">
        Los indicadores se calculan a partir del resumen financiero materializado.
        Vista identica para administradora, comite y residentes.
      </footer>
    </PageContainer>
  );
}
